module.exports = __webpack_public_path__ + "static/media/cross.b229716f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PreviewBook/cross.svg
// module id = 147
// module chunks = 0